import Error500Component from "../../../components/shared/error-components/500-error-component";

function Error500() {
  return <Error500Component />;
}

export default Error500;
